<div class="container">
  <div class="container-item">
    <span class="container-item-message">
      {{ data.message }}
    </span>
    <span class="container-item-alternative">
      {{ data.alternative }}
    </span>
  </div>

  <button mat-button (click)="snackBarRef.dismiss()">
    <span class="text-btn">OK</span>
  </button>
</div>
